import {
  AfterContentInit,
  Component,
  ContentChildren,
  EventEmitter,
  forwardRef,
  Input,
  Output,
  QueryList,
  ViewEncapsulation
} from '@angular/core';

import { SortInfo } from './sort-info';
import { SortableColumnDirective } from './sortable-column.directive';

@Component({
  selector: 'ls-table',
  templateUrl: './table.component.html',
  // tslint:disable-next-line:use-view-encapsulation
  encapsulation: ViewEncapsulation.None
})
export class TableComponent implements AfterContentInit {
  @Input()
  public loading = false;
  @Input()
  public cols = 0;
  @Input()
  public defaultSortInfo: SortInfo;
  @Output()
  public sortTable: EventEmitter<{
    sortField: string;
    direction: string;
  }> = new EventEmitter();
  @ContentChildren(forwardRef(() => SortableColumnDirective))
  public sortableColumnComponents: QueryList<SortableColumnDirective>;

  private currentSortField: string;
  private currentDirection: string;

  public ngAfterContentInit(): void {
    this.sortableColumnComponents.forEach(
      (sortableColumn: SortableColumnDirective) => {
        sortableColumn.registerTable(this);
      }
    );

    if (this.defaultSortInfo) {
      this.sort(this.defaultSortInfo);
    }
  }

  public sort(sortInfo: SortInfo): void {
    if (this.currentSortField === sortInfo.sortField) {
      this.currentDirection === 'ASC'
        ? (this.currentDirection = 'DESC')
        : (this.currentDirection = 'ASC');
    } else {
      this.currentSortField = sortInfo.sortField;
      this.currentDirection = 'ASC';
    }

    this.sortableColumnComponents.forEach(
      (sortableColumn: SortableColumnDirective) => {
        sortableColumn.updateCurrentSorting(
          sortInfo.sortField,
          this.currentDirection
        );
      }
    );

    this.sortTable.emit({
      sortField: sortInfo.sortField,
      direction: this.currentDirection
    });
  }
}
